/* searchtoggle */
$(function() {
    var searchToggle = $('.searchToggleTrigger');
    var searchBar = $('.searchBarElement');
    var searchBarFocusElement = $('.searchBarFocus');
    var searchClose = $('.searchClose');

    var close_search = function close_search() {
        searchToggle.removeClass('__active');
        searchBar.removeClass('__active');
        searchBar.slideUp();
        searchBar.attr('aria-hidden', 'true');
        searchBar.attr('tabindex', '-1');
        searchBar.attr('aria-expanded', 'false');
        searchToggle.focus();
    }

    var open_search = function open_search() {
        searchToggle.addClass('__active');
        searchBar.addClass('__active');
        searchBar.slideDown();
        searchBar.attr('aria-hidden', 'false');
        searchBar.attr('tabindex', '0');
        searchBar.attr('aria-expanded', 'true');
        searchBarFocusElement.focus();
    }

    searchToggle.click(function (event) {
        event.preventDefault();

        if (searchBar.attr('aria-hidden') === ('false')) {
            close_search();
        } else {
            open_search();
        }
    });

    searchClose.click(function (event) {
        event.preventDefault();
        close_search();
    });

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            close_search();
        }
    });
});
